import React from 'react'

import {Field} from 'redux-form'

import * as colors from 'material-ui/styles/colors';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import MenuItem from 'material-ui/MenuItem';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

import FormText from './FormText'

const FormGrLe = ({ name, label, onChange, menuValue }) => {
  return (
    <div>
      <Field
        name={name}
        component={FormText}
        label={label}
        style={{ width: '55%', float: 'left' }}
      />
      <div style={{ float: 'left', height: '100%', paddingTop: '38px', marginLeft: 10 }}>
        <span style={{ color: colors.grey500 }}>{menuValue === 1 ? '<=' : '>='}</span>
      </div>
      <div style={{ float: 'left', height: '100%', paddingTop: '27px' }}>
        <IconMenu
          iconButtonElement={<IconButton iconStyle={{ color: colors.grey500 }}><MoreVertIcon /></IconButton>}
          onChange={onChange}
          value={menuValue}
          style={{ display: 'inline', marginTop: 10 }}
        >
          <MenuItem key={1} value={1} primaryText="<=" />
          <MenuItem key={2} value={2} primaryText=">=" />
        </IconMenu>
      </div>
    </div>
)}

export default FormGrLe


// WEBPACK FOOTER //
// ./src/components/FormGrLe.js